export const __DEV__ = process.env && process.env.toString() === 'development'
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || ''
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || ''
export const CONFIGCAT_KEY = process.env.REACT_APP_CONFIGCAT_KEY || ''
